import { fastapiService } from '../../services/fastapiService';

const BASE = '/admin/voice-infrastructure';

export const voiceInfraApi = {
  providers: () => fastapiService.request(`${BASE}/providers`),
  upsertProvider: (body: unknown) =>
    fastapiService.request(`${BASE}/providers`, { method: 'POST', body }),
  trunks: () => fastapiService.request(`${BASE}/sip-trunks`),
  createTrunk: (body: unknown) =>
    fastapiService.request(`${BASE}/sip-trunks`, { method: 'POST', body }),
  updateTrunk: (id: string, body: unknown) =>
    fastapiService.request(`${BASE}/sip-trunks/${id}`, { method: 'PATCH', body }),
  carriers: () => fastapiService.request(`${BASE}/carriers`),
  geoRoutes: () => fastapiService.request(`${BASE}/geo-routes`),
  createGeoRoute: (body: unknown) =>
    fastapiService.request(`${BASE}/geo-routes`, { method: 'POST', body }),
  phones: (workspaceId?: string) =>
    fastapiService.request(`${BASE}/phone-numbers`, {
      params: workspaceId ? { workspace_id: workspaceId } : undefined,
    }),
  upsertPhone: (body: unknown) =>
    fastapiService.request(`${BASE}/phone-numbers`, { method: 'POST', body }),
  workspaceConfig: (workspaceId: string) =>
    fastapiService.request(`${BASE}/workspace-config/${workspaceId}`),
  upsertWorkspaceConfig: (body: unknown) =>
    fastapiService.request(`${BASE}/workspace-config`, { method: 'PUT', body }),
  failover: () => fastapiService.request(`${BASE}/failover-rules`),
  health: () => fastapiService.request(`${BASE}/health`),
  diagnostics: (workspaceId?: string) =>
    fastapiService.request(`${BASE}/diagnostics`, {
      params: workspaceId ? { workspace_id: workspaceId } : undefined,
    }),
  resolve: (body: unknown) =>
    fastapiService.request(`${BASE}/resolve`, { method: 'POST', body }),
  voicePlatforms: () => fastapiService.request(`${BASE}/voice-platforms`),
  voicePlatformAudit: (params?: { workspace_id?: string; limit?: number }) =>
    fastapiService.request(`${BASE}/voice-platform-audit`, { params }),
  workspaceVoicePlatform: (workspaceId: string) =>
    fastapiService.request(`${BASE}/workspace/${workspaceId}/voice-platform`),
  setWorkspaceVoicePlatform: (
    workspaceId: string,
    body: { platform_code: string; reason?: string }
  ) =>
    fastapiService.request(`${BASE}/workspace/${workspaceId}/voice-platform`, {
      method: 'PUT',
      body,
    }),
  validateWorkspaceVoicePlatform: (
    workspaceId: string,
    body: { platform_code: string }
  ) =>
    fastapiService.request(`${BASE}/workspace/${workspaceId}/voice-platform/validate`, {
      method: 'POST',
      body,
    }),
};
